import { merchantApi } from '@/config/axios'

/** ---------- 自提点 ---------- */
export interface GroupbuyPickupPointVO {
  id?: number
  shopId?: number
  pointName: string
  address?: string
  picUrl?: string
  lat?: number
  lng?: number
  contactName?: string
  contactPhone?: string
  status?: number
  remark?: string
}

export const getPickupPointPage = (params: Recordable) =>
  merchantApi.get({ url: '/merchant-api/groupbuy/pickup-point/page', params })

export const getPickupPoint = (id: number) =>
  merchantApi.get({ url: '/merchant-api/groupbuy/pickup-point/get', params: { id } })

export const createPickupPoint = (data: GroupbuyPickupPointVO) =>
  merchantApi.post({ url: '/merchant-api/groupbuy/pickup-point/create', data })

export const updatePickupPoint = (data: GroupbuyPickupPointVO) =>
  merchantApi.put({ url: '/merchant-api/groupbuy/pickup-point/update', data })

export const updatePickupPointStatus = (id: number, status: number) =>
  merchantApi.put({ url: '/merchant-api/groupbuy/pickup-point/update-status', params: { id, status } })

export const deletePickupPoint = (id: number) =>
  merchantApi.delete({ url: '/merchant-api/groupbuy/pickup-point/delete', params: { id } })

/** ---------- 团长 ---------- */
export interface GroupbuyLeaderVO {
  id?: number
  shopId?: number
  memberId?: number
  realName?: string
  phone?: string
  idCardFrontUrl?: string
  idCardBackUrl?: string
  pickupPointId?: number
  pickupPointName?: string
  pickupPointAddress?: string
  pickupPointPicUrl?: string
  status?: string
  rejectReason?: string
  createTime?: string
}

export const getLeaderPage = (params: Recordable) =>
  merchantApi.get({ url: '/merchant-api/groupbuy/leader/page', params })

export const approveLeader = (id: number, pickupPointId?: number) =>
  merchantApi.put({
    url: '/merchant-api/groupbuy/leader/approve',
    data: pickupPointId != null ? { id, pickupPointId } : { id }
  })

export const rejectLeader = (id: number, rejectReason: string) =>
  merchantApi.put({ url: '/merchant-api/groupbuy/leader/reject', data: { id, rejectReason } })

export const disableLeader = (id: number) =>
  merchantApi.put({ url: '/merchant-api/groupbuy/leader/disable', params: { id } })

export const enableLeader = (id: number) =>
  merchantApi.put({ url: '/merchant-api/groupbuy/leader/enable', params: { id } })

/** ---------- 司机 ---------- */
export interface GroupbuyDriverVO {
  id?: number
  shopId?: number
  driverName: string
  driverPhone: string
  plateNo?: string
  idCardFrontUrl?: string
  idCardBackUrl?: string
  licenseFrontUrl?: string
  licenseBackUrl?: string
  status?: string
  bindMemberId?: number
  bindTime?: string
  auditBy?: string
  auditTime?: string
  rejectReason?: string
  createTime?: string
}

export const getDriverPage = (params: Recordable) =>
  merchantApi.get({ url: '/merchant-api/groupbuy/driver/page', params })

export const getDriver = (id: number) =>
  merchantApi.get({ url: '/merchant-api/groupbuy/driver/get', params: { id } })

export const approveDriver = (id: number) =>
  merchantApi.put({ url: '/merchant-api/groupbuy/driver/approve', data: { id } })

export const rejectDriver = (id: number, rejectReason: string) =>
  merchantApi.put({ url: '/merchant-api/groupbuy/driver/reject', data: { id, rejectReason } })

export const disableDriver = (id: number) =>
  merchantApi.put({ url: '/merchant-api/groupbuy/driver/disable', params: { id } })

export const enableDriver = (id: number) =>
  merchantApi.put({ url: '/merchant-api/groupbuy/driver/enable', params: { id } })

/** ---------- 活动 ---------- */
export interface GroupbuyActivityItemVO {
  id?: number
  skuId: number
  spuId?: number
  groupPrice: number
  activityStock: number
  soldCount?: number
  perLimit?: number
}

export interface GroupbuyActivityVO {
  id?: number
  shopId?: number
  name: string
  status?: string
  startTime: string
  cutTime: string
  planDeliveryTime?: string
  /** @deprecated 兼容；以 pickupPointIds 为准 */
  pickupPointId?: number
  /** 一团多点：覆盖自提点 ID 列表 */
  pickupPointIds?: number[]
  deliveryFeeMode?: number
  deliveryFeeAmount?: number
  /** 团长佣金比例（百分比）；空则用平台默认 */
  commissionRate?: number
  items?: GroupbuyActivityItemVO[]
}

export const getActivityPage = (params: Recordable) =>
  merchantApi.get({ url: '/merchant-api/groupbuy/activity/page', params })

export const getActivity = (id: number) =>
  merchantApi.get({ url: '/merchant-api/groupbuy/activity/get', params: { id } })

export const createActivity = (data: GroupbuyActivityVO) =>
  merchantApi.post({ url: '/merchant-api/groupbuy/activity/create', data })

export const copyActivity = (id: number) =>
  merchantApi.post({ url: '/merchant-api/groupbuy/activity/copy', params: { id } })

export const updateActivity = (data: GroupbuyActivityVO) =>
  merchantApi.put({ url: '/merchant-api/groupbuy/activity/update', data })

export const publishActivity = (id: number) =>
  merchantApi.put({ url: '/merchant-api/groupbuy/activity/publish', params: { id } })

export const cutEarlyActivity = (id: number) =>
  merchantApi.put({ url: '/merchant-api/groupbuy/activity/cut-early', params: { id } })

/** 本波发车（边卖边送；兼容 cut-early） */
export const dispatchWaveActivity = (id: number) =>
  merchantApi.put({ url: '/merchant-api/groupbuy/activity/cut-early', params: { id } })

export const cancelActivity = (id: number) =>
  merchantApi.put({ url: '/merchant-api/groupbuy/activity/cancel', params: { id } })

/** ---------- 批次 ---------- */
export interface GroupbuyBatchOrderItemVO {
  skuId?: number
  spuId?: number
  spuName?: string
  picUrl?: string
  count?: number
  /** 单价（分） */
  price?: number
  /** 行实付（分） */
  payPrice?: number
}

export interface GroupbuyBatchOrderVO {
  orderRefId?: number
  tradeOrderId?: number
  tradeOrderNo?: string
  tradeStatus?: number
  /** 实付金额（分） */
  payPrice?: number
  deliveryFeeShare?: number
  pickupCode?: string
  pickupCodeStatus?: number
  leaderSorted?: boolean
  createTime?: string
  items?: GroupbuyBatchOrderItemVO[]
}

export interface GroupbuyBatchVO {
  id?: number
  activityId?: number
  activityName?: string
  batchNo?: string
  shopId?: number
  pickupPointId?: number
  pickupPointName?: string
  pickupPointAddress?: string
  status?: string
  driverId?: number
  driverName?: string
  driverPhone?: string
  batchFee?: number
  orderCount?: number
  pickupImgs?: string
  doneImgs?: string
  abnormalReason?: string
  abnormalImgs?: string
  abnormalCode?: string
  abnormalTime?: string
  assignTime?: string
  pickedTime?: string
  deliveredTime?: string
  createTime?: string
}

export interface GroupbuyBatchDetailVO extends GroupbuyBatchVO {
  orders?: GroupbuyBatchOrderVO[]
}

export const getBatchPage = (params: Recordable) =>
  merchantApi.get({ url: '/merchant-api/groupbuy/batch/page', params })

export const getBatchDetail = (id: number) =>
  merchantApi.get({ url: '/merchant-api/groupbuy/batch/get', params: { id } })

export const assignBatchDriver = (batchId: number, driverId: number) =>
  merchantApi.put({ url: '/merchant-api/groupbuy/batch/assign', data: { batchId, driverId } })

export const markBatchPicked = (batchId: number, proofImageUrls: string[]) =>
  merchantApi.put({
    url: '/merchant-api/groupbuy/batch/mark-picked',
    data: { batchId, proofImageUrls }
  })

export const markBatchDelivered = (batchId: number, proofImageUrls: string[]) =>
  merchantApi.put({
    url: '/merchant-api/groupbuy/batch/mark-delivered',
    data: { batchId, proofImageUrls }
  })

export const markBatchAbnormal = (batchId: number, abnormalReason: string) =>
  merchantApi.put({
    url: '/merchant-api/groupbuy/batch/mark-abnormal',
    data: { batchId, abnormalReason }
  })

export const cutOffActivityBatches = (activityId: number) =>
  merchantApi.post({ url: '/merchant-api/groupbuy/batch/cut-off', params: { activityId } })

/** ---------- 对账 ---------- */
export interface GroupbuyReportSummaryVO {
  batchCount?: number
  batchFeeTotal?: number
  commissionCount?: number
  commissionAmountTotalFen?: number
}

export const getReportSummary = (params?: { activityId?: number }) =>
  merchantApi.get({ url: '/merchant-api/groupbuy/report/summary', params })

export const getReportBatches = (params?: { activityId?: number }) =>
  merchantApi.get({ url: '/merchant-api/groupbuy/report/batches', params })

export const getReportOrders = (params?: { activityId?: number }) =>
  merchantApi.get({ url: '/merchant-api/groupbuy/report/orders', params })

export const exportReportExcel = (params?: { activityId?: number }) =>
  merchantApi.download({ url: '/merchant-api/groupbuy/report/export-excel', params })
